var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDiscountOrdering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4593",
    height: 512,
    viewBox: "0 0 16.933333 16.933334",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect5339",
    d: "m34.774 274.321h35.435v25.702h-35.435z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4544",
    d: "m-535.214-48.848h501.574v185.586h-501.574z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect11019",
    d: "m36.669 153.503h29.654v28.999h-29.654z",
    transform: "rotate(-90)",
    vectorEffect: "none"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect11446",
    d: "m-143.933 265.779h28.84v29.104h-28.84z",
    transform: "rotate(-90)",
    vectorEffect: "none"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11781"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect11783",
    height: 32.411,
    rx: 0.634,
    transform: "rotate(-90)",
    width: 32.941,
    x: -145.124,
    y: 181.377
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect11501",
    d: "m-551.399-9.261h16.064v16.347h-16.064z",
    vectorEffect: "none"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -280.067)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#d1dcff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6068",
    d: "m7.2346997 288.20052v5.93814h2.463933v-5.93814z",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5598",
    d: "m2.5190227 288.20052v5.93814h2.4639321v-5.93814z",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5607",
    d: "m12.005007 288.20052v5.93814h2.463933v-5.93814z",
    vectorEffect: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6070",
    d: "m7.2347007 293.15061v.98805h2.463932v-.98805z",
    fill: "#bfd2ff",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5963",
    d: "m12.005008 293.15061v.98805h2.463932v-.98805z",
    fill: "#bfd2ff",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5726",
    d: "m4.0315918 293.15061c-.4410487.00052-.688031.64089-.4159951.98805h1.3673581v-.98805z",
    fill: "#bfd2ff",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5812",
    d: "m1.8185545 286.81513v1.18902c0 .29316.2360084.52917.5291667.52917h2.7615885c.2931584 0 .5291667-.23601.5291667-.52917v-1.18902z",
    fill: "#666",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5969",
    d: "m11.327013 286.81513v1.18902c0 .29316.236008.52917.529166.52917h2.761589c.293158 0 .529167-.23601.529167-.52917v-1.18902z",
    fill: "#666",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6074",
    d: "m6.5567057 286.81513v1.18902c0 .29316.236008.52917.529166.52917h2.761589c.2931583 0 .5291673-.23601.5291673-.52917v-1.18902z",
    fill: "#666",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5594",
    d: "m1.3229164 294.00656h14.2875086c.439738 0 .79375.35401.79375.79375v.87676c0 .43973-.354012.79375-.79375.79375h-14.2875086c-.43973745 0-.79374994-.35402-.79374994-.79375v-.87676c0-.43974.35401249-.79375.79374994-.79375z",
    fill: "#55a1ff",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10476",
    d: "m6.8730469 25.505859v3.275123h14.4375001v-3.275123zm17.9082031 0v3.275123h14.4375v-3.275123zm18.029297 0v3.275123h8.913228c2.316517 0 2.055333-3.275123 0-3.275123z",
    fill: "#4d4d4d",
    transform: "matrix(.265 0 0 .265 0 280.067)",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5738",
    d: "m58.634766 22.003906c-.466544.861472-1.161635.915443-1.978516.929688h-45.427734c-1.569024.0019-2.5252127 1.727014-1.6953129 3.058594h47.4667969c2.538503 0 4.618452-1.875343 4.949219-4.320313-1.273695-1.158737-2.746817-.984204-3.314453.332031z",
    fill: "#488bff",
    transform: "matrix(.265 0 0 .265 0 280.067)",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5588",
    d: "m28.374289 3.5501288c-10.136234 5.7031222-19.7604017 11.0727482-26.374289 14.8912772v2.550782c0 2.769999 2.2300001 5 5 5h50c2.77 0 5-2.230001 5-5v-2.550782c-8.371513-4.703918-16.073654-8.96171-26.147429-14.8246311-3.6934-2.1323854-3.852554-2.1599611-7.478282-.0666461z",
    fill: "#55a1ff",
    transform: "matrix(.265 0 0 .265 0 280.067)",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path5736",
    cx: 8.325,
    cy: 284.278,
    fill: "#ffc861",
    r: 1.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5745",
    d: "m33.226562 16.349609c-.222801 1.142572-1.209273 1.436671-1.970703 1.388672-1.359477-.154743-2.469517 1.070574-2.18164 2.408203.729765.413128 1.553989.630454 2.392578.63086 2.68483-.000017 4.861311-2.176498 4.861328-4.861328-.0011-.244617-.02071-.4888-.05859-.730469-1.427188-.933008-2.860062.02354-3.042973 1.164062z",
    fill: "#ffab61",
    transform: "matrix(.265 0 0 .265 0 280.067)",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6231",
    d: "m2.691317 295.66415a.52929999.52929999 0 0 0 -.450102.80667h13.36921c.439738 0 .79375-.35401.79375-.79375v-.0129z",
    fill: "#488bff",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDiscountOrdering);
export default __webpack_public_path__ + "static/media/payment-discount-ordering.e5e7e07946c1cb3e1740ce5f6b5ab287.svg";
export { ForwardRef as ReactComponent };